<section>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="sticky-top secondary-menu-sticky-top z-index-0">
          <div class="secondary-menu">
            <ul class="list-unstyled mb-0">
              <li *ngFor="let navigation of navigations; let i = index">
                <a
                  class="{{ stylesArray[i] }}"
                  [routerLink]="[navigation.route]"
                  (click)="onMenuClicked(i)"
                >
                  {{ navigation.title }}
                  <span class="notification-count" *ngIf="unreadCount > 0 && isMessagesTab(navigation)">
                    {{unreadCount}}
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
